import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useToast, useAuth, usePage, usePopup } from "@/comn/hooks"; // hook
import {
    URLS,
    APIS,
    SF_BLL_REUS_DTL_SRCH,
    SF_BLL_REUS_DTL,
    SG_BLL_REUS_DTL_BLL_LIST,
    SG_BLL_REUS_DTL_LIST,
    SG_BLL_ITM_LIST,
} from "./services/OsciBllReusService"; // 서비스
import { APIS_COMN, SF_COMN_TANSAD_INFO } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";
import { SF_APRV_RQST } from "@/comn/comn/aprv/service/AprvService";
import { OgaAprvRqst } from "@/comn/comn/aprv/OgaAprvRqst";
import { calcLength } from "framer-motion";

/*
 * Bill Reus Detail
 * !== 고지 재사용 상세 ==!
 */
export const OSCI0403005Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "coCd" },
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "comnCd", comnCd: "OSC0023" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { bllMgmtId } = useParams();
    const { aprvYn } = useParams();
    const [searchParams] = useSearchParams();
    const reusRqstSn = searchParams.get("reusRqstSn") || undefined;
    const getEffectiveReusRqstSn = () => reusRqstSn || form.bllReusDtl.getValue("reusRqstSn") || undefined;
    const getEffectiveBllMgmtId = () => form.bllReusDtl.getValue("bllMgmtId") || bllMgmtId;

    // 폼 처리
    const [isReffTansad, setIsReffTansad] = useState(false);

    const [vsdDtls, setVsdDtls] = useState(false);
    const [vsdItms, setVsdItms] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));
    const [bllItmList, setBllItmList] = useState(comnUtils.getGridData([]));

    // 버튼 처리
    const [isVisibleBtn, setIsVisibleBtn] = useState(false);
    const [reusStatCd, setReusStatCd] = useState("R");
    // Reuse rejected by ZanMalipo (F): show the error. To retry, register a new reuse request.
    // !== ZanMalipo 가 재사용을 거절함(F): 오류를 보여 준다. 다시 보내려면 재사용을 새로 등록한다. ==!
    const [isReusFail, setIsReusFail] = useState(false);

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0096" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Bill Reus Detail Search !== 고지 재사용 상세 조회 ==!
        bllReusDtlSrch: useForm({
            defaultSchema: SF_BLL_REUS_DTL_SRCH,
            defaultValues: {
                bllMgmtId: bllMgmtId,
            },
        }),

        // Bill Reus Detail  !== 고지 재사용 상세 폼 ==!
        bllReusDtl: useForm({
            defaultSchema: SF_BLL_REUS_DTL,
        }),
        // Common TANSAD Info  !== 공통 TANSAD정보 폼 ==!
        comnTansadInfo: useForm({
            defaultSchema: SF_COMN_TANSAD_INFO,
        }),

        aprvRqstForm: useForm({
            defaultSchema: SF_APRV_RQST,
            defaultValues: {
                ptlTpCd: "O", // 포털 구분 코드 (I: 내부, O: 외부)
                bsopClsfCd: "COL", // 업무 구분 코드
                scrnDocCd: "scrn_colt0010", // 문서 ID
                aprvReffId: "/" + bllMgmtId + "/Y", // 결재 요청 문서 Key 값
                aprvAfPrcssCfgnId: "cfgn_col0019", // 결재완료 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                rtrnAfPrcssCfgnId: "cfgn_col0020", // 반려 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                prevStageRtrnUseYn: "Y", // 이전단계 반려처리가 필요한 경우에만 'Y'로 넘겨 줄 것 (결재처리 시 이전단계반려 라디오버튼을 보여줌)
                itsfAprvYn: "N", // 업무팀 자체 결재처리 시 'Y'로 넘겨 줄 것 (결재처리탭 비활성화)
            },
        }),
    };

    const readyFunc = {
        readyBtn: (data: any) => {
            // const lgnAuthLst = auth.get("authList");
            // const lgnUsrCstmCd = auth.get("cstmCd");
            // const bllSysmCd = data?.bllSysmCd;
            // const aprvPrcssStatCd = data?.aprvPrcssStatCd;
            // const dspoYn = data?.dspoYn;
            // const tansadReustnYn = data?.tansadReustnYn;
            //
            // if ("Y" != dspoYn && "Y" != tansadReustnYn) {
            // if (aprvPrcssStatCd != "A01" && aprvPrcssStatCd != "A03") {
            //     // if (lgnAuthLst.includes("auth_coli0001")) {
            //     setIsVisibleBtn(true);
            //     // } else if (
            //     //     (lgnAuthLst.includes("auth_coli0013") || lgnAuthLst.includes("auth_osci0019")) &&
            //     //     lgnUsrCstmCd == bllSysmCd
            //     // ) {
            //     setIsVisibleBtn(true);
            //     // }
            //     //     }
            // }

            setIsVisibleBtn(false);
            if (data?.reusStatCd && data.reusStatCd === "R") {
                setIsVisibleBtn(true);
            }
            // Only the latest request carries the bill's error !== 고지서 오류는 최신 요청에만 내려온다 ==!
            setIsReusFail(data?.reusStatCd === "F" && !!data?.errMsgCn);
        },
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_BLL_REUS_DTL_LIST,
        }),
        bllItmList: useGrid({
            defaultSchema: SG_BLL_ITM_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Bill Reus Detail !== 고지 재사용 상세 조회 ==!
        getBllReusDtl: useFetch({
            api: () => APIS.getBllReusDtl({ ...form.bllReusDtlSrch.getValues(), reusRqstSn }),
            enabled: !!bllMgmtId,
            onSuccess: (data) => {
                const bllReusData = data.bllReusDtl.content;

                if (!bllReusData?.bllNo) {
                    form.bllReusDtl.reset();
                    form.comnTansadInfo.reset();
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                    return;
                }

                // form 데이터 세팅
                form.bllReusDtl.setValues({
                    ...bllReusData,
                });
                // form 데이터 세팅
                form.bllReusDtlSrch.setValues({
                    ...bllReusData,
                });

                // 버튼 컨트롤
                readyFunc.readyBtn(data.bllReusDtl?.content);

                if (bllReusData?.reffKeyTpCd && bllReusData.reffKeyTpCd === "T") {
                    let reffKeyNo = bllReusData?.reffKeyNo1 + "-" + bllReusData?.reffKeyNo2;
                    if (bllReusData?.reffKeyNo3 != null) {
                        reffKeyNo = reffKeyNo + "-" + bllReusData?.reffKeyNo3;
                    }
                    if (bllReusData?.reffKeyNo4 != null) {
                        reffKeyNo = reffKeyNo + "-" + bllReusData?.reffKeyNo4;
                    }
                    // Reference Key
                    form.bllReusDtl.setValue("reffKey", reffKeyNo);

                    if (bllReusData?.reffKeyTpCd == "T") {
                        const tansadNo =
                            bllReusData?.reffKeyNo1 + "-" + bllReusData?.reffKeyNo2 + "-" + bllReusData?.reffKeyNo3;
                        fetch.getTansadDtl.fetch(tansadNo);
                        setIsReffTansad(true);
                    }
                } else {
                    let reffKeyNo = bllReusData?.reffKeyNo1;
                    form.bllReusDtl.setValue("reffKey", reffKeyNo);
                }

                if (data.bllReusDtl.content.bllDtls && data.bllReusDtl.content.bllDtls.length > 0) {
                    setVsdDtls(true);
                    setBllDtlList(comnUtils.getGridData(data.bllReusDtl.content.bllDtls));
                }
                if (data.bllReusDtl.content.bllItms) {
                    setVsdItms(true);
                    setBllItmList(comnUtils.getGridData(data.bllReusDtl.content.bllItms));
                }
            },
            onError: () => {},
            showToast: true,
        }),
        // Get TANSAD Detail !== TANSAD 상세 조회 ==!
        getTansadDtl: useFetch({
            api: (tansadNo) => APIS_COMN.getTansad(tansadNo),
            onSuccess: (data) => {
                const tansadData = data.tansadInfo.content;

                if (!tansadData?.tansadNo) {
                    form.bllReusDtl.reset();
                    form.comnTansadInfo.reset();

                    modal.openModal({
                        content: "msg.osc.00146", // Please check TANSAD No.
                    });
                    return;
                }

                const exppnImppnTinNm =
                    colUtils.setMask(tansadData.exppnImppnTin, "tin") + "(" + tansadData.exppnImppnNm + ")";
                const dcltTinNm = colUtils.setMask(tansadData.dcltTin, "tin") + "(" + tansadData.dcltNm + ")";

                // form 데이터 세팅
                form.comnTansadInfo.setValues({
                    ...tansadData,
                    exppnImppnTinNm: exppnImppnTinNm,
                    dcltTinNm: dcltTinNm,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // Delete Bill Reus !== 고지 재사용 삭제 ==!
        deleteBllReus: useFetch({
            api: (bllMgmtId, reusRqstSnArg) => APIS.deleteBllReus(bllMgmtId, reusRqstSnArg),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006", // 성공적으로 처리 되었습니다.
                    onConfirm: () => {
                        navigate(`${URLS.osci0403004q}`);
                    },
                    onCancel: () => {
                        navigate(`${URLS.osci0403004q}`);
                    },
                });
            },
            onError: (error) => {
                // Business errors (e.g. the request is already sent) carry their own message; reload to show the current status
                // !== 업무 오류(이미 전송된 요청 등)는 서버 메시지를 보여 주고, 닫으면 현재 상태로 다시 조회한다 ==!
                const errorMessage = error?.response?.data?.errorMessage;
                const serverMsg = typeof errorMessage === "string" ? errorMessage : errorMessage?.content;
                modal.openModal({
                    content: serverMsg || "msg.osc.00015", //An error occurred during processing.
                    onClose: () => {
                        fetch.getBllReusDtl.fetch();
                    },
                });
            },
        }),
        // Bill Reus Approval Request After !== 고지 재사용 승인 결재 요청 후처리 ==!
        bllReusAprvRqstAf: useFetch({
            api: (data) => APIS.bllReusAprvRqstAf(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        navigate(URLS.osci0403004q);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0403004q);
                    },
                });
            },
            onError: (data) => {},
            showToast: true,
        }),
        reusBll: useFetch({
            api: (data) => {
                return APIS.reusBll(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006", //Processed successfully.
                    onClose: () => {
                        fetch.getBllReusDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                // Business errors (e.g. the request is already sent) carry their own message; reload to show the current status
                // !== 업무 오류(이미 전송된 요청 등)는 서버 메시지를 보여 주고, 닫으면 현재 상태로 다시 조회한다 ==!
                const errorMessage = error?.response?.data?.errorMessage;
                const serverMsg = typeof errorMessage === "string" ? errorMessage : errorMessage?.content;
                modal.openModal({
                    content: serverMsg || "msg.osc.00015", //An error occurred during processing.
                    onClose: () => {
                        fetch.getBllReusDtl.fetch();
                    },
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Processing History List !== 처리 이력 목록 조회 ==!
        getPrcsHistLst: () => {
            let tansadNo = form.comnTansadInfo.getValue("tansadNo");
            tansadNo = colUtils.setMask(tansadNo, "tansadNo");

            // Declaration 처리이력 (팝업)
            popup.openPopup({
                id: "tansadPrcsHistLstPpup",
                url: URLS.clri0801029q,
                params: tansadNo,
                size: "lg",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
        // Go Update Form !== 수정 화면 이동 ==!
        goUpdateForm: () => {
            const effectiveBllMgmtId = getEffectiveBllMgmtId();
            const effectiveReusRqstSn = getEffectiveReusRqstSn();
            navigate(
                URLS.osci0403006s +
                    "/UPDATE" +
                    "/" +
                    effectiveBllMgmtId +
                    (effectiveReusRqstSn ? `?reusRqstSn=${effectiveReusRqstSn}` : ""),
            );
        },
        // Delete Bill Reus !== 고지 재사용 삭제 ==!
        deleteBllReus: () => {
            form.bllReusDtl.handleSubmit(
                (data) => {
                    modal.openModal({
                        content: t("msg.osc.00038", { "0": "Reus" }), // Do you want to remove Reus?
                        onConfirm: () => {
                            fetch.deleteBllReus.fetch(getEffectiveBllMgmtId(), getEffectiveReusRqstSn());
                        },
                    });
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // 데이터가 유효하지 않습니다.
                },
            )();
        },
        // Click Apprvoal Request Button !== 결재 요청 버튼 클릭 ==!
        onAprvRqstBtnClick: () => {
            modal.openModal({
                // url: "/comn/comn/ppup/aprvRqstPpup",
                // params: {
                //     bsopClsfCd: "COL", //업무시스템 구분
                //     scrnDocCd: "scrn_colt0010", //화면문서코드테이블에 등록된 화면문서ID
                //     aprvReffId: "/" + bllNo + "/Y", //결재문서 조회를 위한 결재참고ID
                //     aprvAfPrcssCfgnId: "cfgn_col0019", // 결재 승인 후 처리 설정 테이블에 등록된 후처리ID
                //     rtrnAfPrcssCfgnId: "cfgn_col0020", // 결재 반려 후 처리 설정 테이블에 등록된 후처리ID
                // },
                // size: "md",
                // draggable: true,
                // callback: (data) => {
                //     // !== 결재완료 후 해당 callback 함수에 결재번호를 리턴해줌  ==!
                //     console.log("Check Data 결재아이디 >>>>> ", data.aprvId);
                //     modal.closeModal();

                //     const param = { ...form.bllReusDtlSrch.getValues(), aprvId: data.aprvId };

                //     // // 결재상신 후 처리
                //     fetch.bllReusAprvRqstAf.fetch(param);
                // },
                content: (
                    <OgaAprvRqst
                        paramData={{
                            bsopClsfCd: "COL", // 업무시스템 구분
                            scrnDocCd: "scrn_colt0010", // 화면문서코드테이블에 등록된 화면문서ID
                        }}
                        callbackFn={(aprvData: any) => {
                            if (aprvData) {
                                form.aprvRqstForm.setValues({
                                    aprvId: aprvData.aprvId,
                                    aprvRqstTtleNm: aprvData.aprvRqstTtleNm,
                                    aprvRqstCn: aprvData.aprvRqstCn,
                                    usrDmnId: aprvData.usrDmnId,
                                    aprvPrcssPathMgmtId: aprvData.aprvPrcssPathMgmtId,
                                });

                                const param = {
                                    ...form.bllReusDtlSrch.getValues(),
                                    reusRqstSn: getEffectiveReusRqstSn(),
                                    aprvRqstDto: form.aprvRqstForm.getValues(),
                                };
                                console.log("callbackFn data", param);
                                fetch.bllReusAprvRqstAf.fetch(param);
                            }
                            modal.closeModal("OgaAprvRqst");
                        }}
                    />
                ),
                size: "md",
                draggable: true,
                close: false,
                id: "OgaAprvRqst",
            });
        },
        reuseBill: form.bllReusDtl.handleSubmit(
            () => {
                const data = { ...form.bllReusDtl.getValues() };
                modal.openModal({
                    content: "msg.osc.00180", //Do you want to execute?
                    onConfirm: () => {
                        fetch.reusBll.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {},
            edit: {},
        },
        grid_bllItmList: {
            head: {},
            cell: {},
            edit: {
                bllItmAmt: (props: any) => {
                    const { binding, rowValues, value } = props;

                    return <span>{`${rowValues.bllItmAmt}`}</span>;
                },
            },
        },
    };

    // 팝업 호출
    const popupFunc = {
        // 고지 팝업
        openBllPopup: (bllNo: any) => {
            popup.openPopup({
                url: `${URLS.osci0403007s}/${bllNo}`,
                size: "md",
                layout: "popup",
                callback: (data: any) => {
                    console.log(data);
                },
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.bllReusDtlSrch.setEditable(false);
        form.bllReusDtl.setEditable(false);
        form.comnTansadInfo.setEditable(false);
    }, []);

    return (
        <Page>
            {/* 고지 재사용 상세 조회 */}
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtlSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllReusDtlSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Col>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllTpCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllReusDtlSrch.schema.bllDgr} />
                            </Group.Col>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {isReffTansad && (
                <>
                    {/* TANSAD */}
                    <Group>
                        <Group.Body>
                            <Group.Title title={"T_TANSAD_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.tansadNo} />
                                    <Group.Control {...form.comnTansadInfo.schema.tansadDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.regm} />
                                    <Group.Control {...form.comnTansadInfo.schema.csclPlnCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.exppnImppnTinNm} />
                                    <Group.Control {...form.comnTansadInfo.schema.dcltTinNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.comnTansadInfo.schema.dclrPrcssSttsCd} />
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                </>
            )}
            {/* Bill */}
            <Group>
                <Group.Body>
                    <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.bllNo} />
                            <Group.Control {...form.bllReusDtl.schema.bllDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.ctrlNo} />
                            <Group.Control {...form.bllReusDtl.schema.zmpDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.currCd} />
                            <Group.Control {...form.bllReusDtl.schema.bllStatCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.feeAmt} />
                            <Group.Control {...form.bllReusDtl.schema.feeTzsAmt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.pyerMgmtNo} />
                            <Group.Control {...form.bllReusDtl.schema.payDdlnDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.reffKeyTpCd} />
                            <Group.Control {...form.bllReusDtl.schema.reffKey} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.bllRgsrId} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            {vsdDtls && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                    </Group.Body>
                </Group>
            )}
            {vsdItms && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_ITM_LST"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllItmList.grid} data={bllItmList} render={render.grid_bllItmList} />
                    </Group.Body>
                </Group>
            )}
            {/* Reus */}
            <Group>
                <Group.Body>
                    <Group.Title title={"T_REUS"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.reusRqstDt} />
                            <Group.Control {...form.bllReusDtl.schema.reusStatCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllReusDtl.schema.reusCd} />
                            <Group.Control {...form.bllReusDtl.schema.reusRmrk} />
                        </Group.Row>
                        {isReusFail && (
                            <Group.Row>
                                <Group.Control {...form.bllReusDtl.schema.errRcveDt} />
                                <Group.Control {...form.bllReusDtl.schema.errMsgCn} />
                            </Group.Row>
                        )}
                    </Group.Section>
                </Group.Body>
            </Group>
            {aprvYn != "Y" && (
                <Layout direction="row">
                    <Layout.Left>
                        <Button
                            role="list"
                            onClick={() => {
                                navigate(URLS.osci0403004q);
                            }}
                        ></Button>
                    </Layout.Left>
                    {isVisibleBtn && (
                        <Layout.Right>
                            <Button
                                onClick={() => {
                                    handler.reuseBill();
                                }}
                            >
                                {t("B_ZMP_SEND")}
                            </Button>
                            <Button
                                onClick={() => {
                                    handler.goUpdateForm();
                                }}
                            >
                                {t("B_UPDT")}
                            </Button>
                            <Button
                                role="delete"
                                onClick={() => {
                                    handler.deleteBllReus();
                                }}
                            ></Button>
                            {/* <Button variant="primary" onClick={handler.onAprvRqstBtnClick}>
                                {t("B_APRV_RQST")}
                            </Button> */}
                        </Layout.Right>
                    )}
                </Layout>
            )}
        </Page>
    );
};
